import { h, VNode } from "preact";

export type AlertType = "info" | "warning" | "error" | "success";

export function Alert(props: {
    class?: string,
    type?: AlertType,
    children?: string | string[] | null,
    visible?: boolean,
    title?: string
}) {
    let cls = "alert" + (props.title ? " big" : "");

    if (props.type) {
        cls += " " + props.type;
    }

    if (props.class) {
        cls += " " + props.class;
    }

    if (props.visible === false) {
        cls += " " + "hidden";
    }

    return <div class={cls}>{props.title ? <span>{props.title}</span> : null}{props.children}</div>;
}
